import setGlobalHTML from './set-global-html';
import setGlobalHTMLAndAffectHistory from './set-global-html-and-affect-history';
import detachGlobal from './detach-global';
import resetGlobal from './reset-global';
import setGlobals from './set-globals';

export default {
  setGlobalHTML,
  setGlobalHTMLAndAffectHistory,
  detachGlobal,
  resetGlobal,
  setGlobals,
};
